import React from 'react';
export function FontPickerIcon() {
    return (React.createElement("svg", { width: "25", height: "25", viewBox: "0 0 25 25", xmlns: "http://www.w3.org/2000/svg", "data-aid": "font-picker-icon" },
        React.createElement("path", { d: "M16.5 7h-8C7.673 7 7 7.673 7 8.5V11h1V8.5a.5.5 0 0 1 .5-.5H12v9H9v1h7v-1h-3V8h3.5a.5.5 0 0 1 .5.5V11h1V8.5c0-.827-.673-1.5-1.5-1.5", fill: "#1D2D3C" })));
}
//# sourceMappingURL=FontPickerIcon.js.map